module.exports = __webpack_public_path__ + "img/OrangeFiat300x300.4dfa57cb.jpg";